import loadable from '@loadable/component';

import { Modules } from 'types';

// eslint-disable-next-line
export const loadOutrightModule: () => Promise<
    Modules['outright']
> = /* #__LOADABLE__ */ () =>
    import(/* webpackChunkName: "outright-module" */ './index');

export const AsyncOutrightsList = loadable(loadOutrightModule, {
    resolveComponent: ({ default: outright }) =>
        outright.components.OutrightsList,
});

export const AsyncOutright = loadable(loadOutrightModule, {
    resolveComponent: ({ default: outright }) => outright.components.Outright,
});

export const AsyncOutrightPage = loadable(loadOutrightModule, {
    resolveComponent: ({ default: outright }) =>
        outright.components.OutrightPage,
});

export const AsyncOutrightsBanners = loadable(loadOutrightModule, {
    resolveComponent: ({ default: outright }) =>
        outright.components.OutrightsBanners,
});
